import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableClientDetailsPage = withAsyncLoading(async () =>
    import('./ClientDetailsPage').then((res) => res.ClientDetailsPage)
);

export { LoadableClientDetailsPage };
